(function(algolia) {
  'use strict';
     window.algoliaShopify = window.algoliaShopify || {};
   
      window.algoliaShopify.config = window.algoliaShopify.config || {};

  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = AlgoliaProxy.searchClient();

  algolia.render = (template, container, data) => {
    return render(template(html, data), container);
  };

  var formatPrice = function formatPrice(value, currency = false) {
    return algolia.formatMoney(Number(value) * 100, currency);
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    getMarketCurrency: (market_region) => {
      switch (market_region) {
        case 'US':
          return 'usd';
        case 'GB':
          return 'gbp';
        case 'IL':
          return 'ils';
        case 'RU':
          return 'rub';
        default:
          const euroMarkets = ['FR', 'FI', 'U', 'GR', 'MC', 'IE', 'NL', 'DK', 'SE', 'AT', 'GI', 'MT', 'NO', 'PL', 'RO', 'ME', 'MD', 'LT', 'LI', 'HU', 'IS', 'GE', 'BG', 'BE', 'IT', 'ES', 'PT', 'DE', 'AM', 'AD', 'AL', 'AX', 'BY', 'BA', 'HR', 'CY', 'CZ', 'EE', 'FO', 'GP', 'GG', 'IM', 'JE', 'XK', 'LV', 'MK', 'YT', 'RE', 'SM', 'RS', 'SK', 'SI', 'SJ', 'TR', 'UA', 'VA'];
          return euroMarkets.includes(market_region) ? 'eur' : 'eur';
      }
    },
    getPriceDisplay: (currency, price) => {
      let unit = '€';
      let priceF = parseFloat(price);
      switch(currency.toLowerCase()){
        case 'eur':
          unit = '€';
          break;
        case 'usd':
          unit = '$';
          break;
        case 'gbp':
          unit = '£';
          break;
        case 'ils':
          unit = '₪';
          break;
        case 'rub':
          unit = '₽';
          break;
        default :
          unit = '€';
          break;
      }
      return unit == '€' ? `${priceF?.toFixed(0)}${unit}` : `${unit}${priceF?.toFixed(0)}`;
    },
   isMobile: function isMobile() {
    
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
    
    // const toMatch = [
    //     /Android/i,
    //     /webOS/i,
    //     /iPhone/i,
    //     /iPad/i,
    //     /iPod/i,
    //     /BlackBerry/i,
    //     /Windows Phone/i
    // ];
    
    // return toMatch.some((toMatchItem) => {
    //     return navigator.userAgent.match(toMatchItem);
    // });
    // return navigator.userAgentData.mobile ? 'target' : 'target="_blank"'; 
   },
    marketsEnabled: function marketsEnabled() {
      // Markets disabled for now
      // return algoliaShopify.config.markets_indexing_enabled && algoliaShopify.config.markets_mapping?.length ? true : false;
      return true;
    },
    normalizeMarketId: function normalizeMarketId(marketId) {
      if (marketId == null) return '';
      var s = String(marketId);
      var match = s.match(/(\d+)$/);
      return match ? match[1] : s;
    },
    getMarketsMappingEntry: function getMarketsMappingEntry(market_key, locale) {
      var mapping = algoliaShopify.config.markets_mapping || [];
      var entry = mapping.find(function(value) {
        return value.key === market_key;
      });
      if (entry) return entry;
      var marketId = algolia.helpers.normalizeMarketId(
        (algoliaShopify.shopify && algoliaShopify.shopify.market && algoliaShopify.shopify.market.id) ||
        (algolia.shopify && algolia.shopify.market && algolia.shopify.market.id)
      );
      var loc = locale ||
        (algoliaShopify.shopify && algoliaShopify.shopify.market && algoliaShopify.shopify.market.language && algoliaShopify.shopify.market.language.shop_locale && algoliaShopify.shopify.market.language.shop_locale.locale) ||
        (algolia.shopify && algolia.shopify.market && algolia.shopify.market.language && algolia.shopify.market.language.shop_locale && algolia.shopify.market.language.shop_locale.locale);
      if (!marketId || !loc) return null;
      return mapping.find(function(value) {
        return algolia.helpers.normalizeMarketId(value.id) === marketId && value.locale === loc;
      }) || null;
    },
    // Corrige les suffixes vides ou legacy (primary) → index marché explicite.
    resolveMarketSuffix: function resolveMarketSuffix(market_key, suffixFromMapping, locale) {
      // Le mapping fait foi : un suffixe explicite est respecté tel quel, Y COMPRIS
      // '' (chaîne vide) = marché PRIMAIRE → indice de base sans suffixe.
      if (suffixFromMapping != null) return suffixFromMapping;
      var mapping = algolia.helpers.getMarketsMappingEntry(market_key, locale);
      if (!mapping) return '';
      if (typeof mapping.suffix === 'string') return mapping.suffix;
      // Fallback d'inférence UNIQUEMENT si l'entrée n'a pas de champ suffix.
      if (mapping.regions && mapping.regions.indexOf('US') >= 0) {
        return mapping.locale === 'fr' ? 'united_states_fr' : 'united_states_en';
      }
      if (mapping.market === 'United States') {
        return mapping.locale === 'fr' ? 'united_states_fr' : 'united_states_en';
      }
      if (mapping.regions && mapping.regions.indexOf('FR') >= 0) {
        return mapping.locale === 'fr' ? 'france_fr' : 'france_en';
      }
      if (mapping.market === 'France') {
        return mapping.locale === 'fr' ? 'france_fr' : 'france_en';
      }
      return '';
    },
    marketIndexHyphen: function marketIndexHyphen(market_suffix) {
      return market_suffix === '' ? '' : '_';
    },
    productsIndexName: function productsIndexName(market_key, locale) {
      var mapping = algolia.helpers.getMarketsMappingEntry(market_key, locale);
      var suffix = algolia.helpers.resolveMarketSuffix(market_key, mapping ? mapping.suffix : '', locale);
      var hypen = algolia.helpers.marketIndexHyphen(suffix);
      return algoliaShopify.config.index_prefix + 'products' + hypen + suffix;
    },
    collectionsIndexName: function collectionsIndexName(market_key, locale) {
      var mapping = algolia.helpers.getMarketsMappingEntry(market_key, locale);
      var suffix = algolia.helpers.resolveMarketSuffix(market_key, mapping ? mapping.suffix : '', locale);
      var hypen = algolia.helpers.marketIndexHyphen(suffix);
      return algoliaShopify.config.index_prefix + 'collections' + hypen + suffix;
    },
    defaultProductsIndexName: function defaultProductsIndexName() {
      // US/en est le marché primaire → indice de base sans suffixe.
      return algoliaShopify.config.index_prefix + 'products';
    },
    defaultCollectionsIndexName: function defaultCollectionsIndexName() {
      return algoliaShopify.config.index_prefix + 'collections';
    },
    getCurrentLocale: function getCurrentLocale() {
      var shopify = algoliaShopify.shopify || algolia.shopify || {};
      var market = shopify.market || {};
      return (market.language && market.language.shop_locale && market.language.shop_locale.locale) || 'en';
    },
    getCurrentMarketKey: function getCurrentMarketKey() {
      var shopify = algoliaShopify.shopify || algolia.shopify || {};
      var marketId = algolia.helpers.normalizeMarketId((shopify.market || {}).id);
      return marketId + '_' + algolia.helpers.getCurrentLocale();
    },
    getCurrentProductsIndexName: function getCurrentProductsIndexName() {
      var locale = algolia.helpers.getCurrentLocale();
      return algolia.helpers.productsIndexName(algolia.helpers.getCurrentMarketKey(), locale);
    },
    getCurrentCollectionsIndexName: function getCurrentCollectionsIndexName() {
      var locale = algolia.helpers.getCurrentLocale();
      return algolia.helpers.collectionsIndexName(algolia.helpers.getCurrentMarketKey(), locale);
    },
    getMarketRegion: function getMarketRegion(market_key, locale) {
      var entry = algolia.helpers.getMarketsMappingEntry(market_key, locale);
      return (entry && entry.regions && entry.regions[0]) || 'FR';
    },
    activeCurrencyCode: function activeCurrencyCode() {
      return Shopify.currency.active.toLowerCase();
    },
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    localizeHitData: hit => {
      if(!hit) return hit;
      if (algolia.helpers.marketsEnabled()) {
        hit.currency = algoliaShopify.config.store_currency.toLowerCase();
      }
      
      if (!algolia.helpers.marketsEnabled() || algolia.helpers.activeCurrencyCode() === algoliaShopify.config.store_currency.toLowerCase()) {
        return hit;
      }
      const currencyKey = `market_pricing_${algolia.helpers.activeCurrencyCode()}`;

      if (currencyKey in hit) {
        hit.price = hit[currencyKey]?.price || hit.price;
        hit.compare_at_price = hit[currencyKey]?.compare_at_price || hit.compare_at_price;
        hit.variants_min_price = hit[currencyKey]?.variants_min_price || hit.variants_min_price;
        hit.variants_max_price = hit[currencyKey]?.variants_max_price || hit.variants_max_price;
        hit.variants_compare_at_price_min = hit[currencyKey]?.variants_compare_at_price_min || hit.variants_compare_at_price_min;
        hit.variants_compare_at_price_max = hit[currencyKey]?.variants_compare_at_price_max || hit.variants_compare_at_price_max;
        hit.price_ratio = hit[currencyKey]?.price_ratio || hit.price_ratio;
        hit.currency = currencyKey.split('_').pop();
      }

      return hit;
    },
    displayPrice: function displayPrice(item, distinct) {
      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        var currency = item.currency || false;
        if (min && max && min !== max) {
          return  algoliasearch.translations.from + ' ' + formatPrice(min, currency);
        }
      }
      return formatPrice(item.price, item.currency);
    },
    /**
     * Collection/search card price. Uses cheapest (variants_min) + "From" when
     * prices vary. Respects __OBLIST_VARIANT_DEFAULT__ rollback flag.
     * Visual format matches getPriceDisplay (market currency symbols).
     */
    cardPriceDisplay: function cardPriceDisplay(hit) {
      if (!hit) return '';
      var cfg = window.__OBLIST_VARIANT_DEFAULT__ || { enabled: true, fromPrefix: 'From' };
      var enabled = cfg.enabled !== false;
      var min = hit.variants_min_price;
      var max = hit.variants_max_price;
      var minN = min != null ? Number(min) : NaN;
      var maxN = max != null ? Number(max) : NaN;
      var varies = enabled && !isNaN(minN) && !isNaN(maxN) && minN !== maxN;
      var amount = varies ? minN : hit.price;
      var currency = hit.currency || 'eur';
      var formatted = algolia.helpers.getPriceDisplay
        ? algolia.helpers.getPriceDisplay(currency, amount)
        : (String(Math.round(Number(amount) || 0)) + '€');
      if (!varies) return formatted;
      // Prefer theme locale prefix (FR/EN) over Algolia metafield default
      var from =
        cfg.fromPrefix ||
        (algoliasearch.translations && algoliasearch.translations.from) ||
        'From';
      return from + ' ' + formatted;
    },
    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price, currency) {
      const comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      if (comparing) { return formatPrice(compare_at_price, currency) }
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      if (comparing) { return `- ${Math.floor(discount_ratio * 100)} %`}
    },
    instantsearchLink: function instantsearchLink(hit) {
      
      return (
        Shopify.routes.root +
        'products/' +
        hit.handle
      );
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      // Preventing escaping of title
      // return escapeHtml(res);
      return res;
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : item.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    index_suffix: (function () {
      const ALGOLIA_MARKET_KEY = 'algolia_market';
      let cache_suffix = '';
      let isMemoized = false;

      // console.log('algolia index_suffix function');

      return async function memorizedIndexSuffix() {
        if (isMemoized) return cache_suffix;

        if (algoliaShopify.config.markets_indexing_enabled && algoliaShopify.config.markets_mapping?.length) {
        
          // console.log('markets - checking for market changes')
          // Check if market has changed, if changed, update market
          let shouldCheckMarketIndex = true;
          try {
            const marketStorage = JSON.parse(localStorage.getItem(ALGOLIA_MARKET_KEY) || '{}');
            
            if (
              marketStorage.id == algolia.shopify.market.id && 
              marketStorage.locale == algolia.shopify.market.language.shop_locale.locale
            ) {
              cache_suffix = marketStorage.suffix ? `_${marketStorage.suffix}` : '';
              shouldCheckMarketIndex = false;
              isMemoized = true;
            } 
          } catch (e) {
            localStorage.removeItem(ALGOLIA_MARKET_KEY);
            cache_suffix = '';
            isMemoized =true;
          }
          
          if(shouldCheckMarketIndex) {
            try {
              // key = {market_id}_{market_language}
              const key = `${algolia.shopify.market.id}_${algolia.shopify.market.language.shop_locale.locale}`;
              const market = algoliaShopify.config.markets_mapping.find(market => market.key === key);
              if(market) {
                const indexSuffix = market.suffix ? `_${market.suffix}` : '';

                // indexName = {prefix}_{type}_{market_title}_{language_code}
                const indexName = `${algoliaShopify.config.index_prefix}products${indexSuffix}`;
                const index = AlgoliaProxy.searchClient().initIndex(indexName);

                await index.search({ analytics: false, page: 1, hitsPerPage: 1 })
                cache_suffix = indexSuffix;
                localStorage.setItem(ALGOLIA_MARKET_KEY, JSON.stringify(market));
                isMemoized = true;
              }
            } catch (e) {
              localStorage.removeItem(ALGOLIA_MARKET_KEY);
              cache_suffix = '';
              isMemoized = true;
            }
          }
          return cache_suffix;
        }
        
      }
    })(),
  };
  
  // algoliaShopify.config.index_suffix = algolia.helpers.index_suffix();

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item) {
        var image = item.product_image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    };
  });
})(window.algoliasearch);
